import { HubConnectionBuilder, LogLevel, HttpTransportType, HubConnectionState } from '@microsoft/signalr';
import store from '../config/store';

class TefService {
  constructor() {
    this.signalR = new HubConnectionBuilder()
      .withUrl(`${store.terminalTefUrl}/hubs/tef`, {
        skipNegotiation: true,
        transport: HttpTransportType.WebSockets
      })
      .configureLogging(LogLevel.Debug)
      .withAutomaticReconnect()
      .build();
    this.isDisconnecting = false;
  }

  async connect() {
    if (this.signalR && this.signalR.state === "Disconnected") {
      await this.signalR.start();
    }
  }

  async disconnect() {
    if (this.signalR && this.signalR.state === "Connected") {
      if (this.isDisconnecting) return;
      this.isDisconnecting = true;
      try {
        await this.signalR.stop();
        console.log("Conexão encerrada com sucesso");
      } catch (err) {
        console.error("Erro ao encerrar conexão:", err);
      } finally {
        this.isDisconnecting = false;
      }
    }
  }

  onReconnecting(callbackFunction) {
    if (this.signalR) {
      this.signalR.onreconnecting(callbackFunction);
    }
  }

  onReconnected(callbackFunction) {
    if (this.signalR) {
      this.signalR.onreconnected(callbackFunction);
    }
  }

  onClose(callbackFunction) {
    if (this.signalR) {
      return this.signalR.onclose((error) => {
        if (!this.isDisconnecting) {
          callbackFunction(error);
        }
      });
    }
  }

  onInicializaTef(subcribleFunction) {
    if (this.signalR) {
      this.signalR.on('InicializaTefSucesso', subcribleFunction);
    }
  }

  onFinalizacaoTef(subcribleFunction) {
    if (this.signalR) {
      this.signalR.on('FinalizacaoTef', subcribleFunction);
    }
  }

  onExibeMensagemTef(mensagem) {
    if (this.signalR) {
      this.signalR.on('ExibeMensagemTef', mensagem);
    }
  }

  onMontaMenuTef(subcribleFunction) {
    if (this.signalR) {
      this.signalR.on('MontaMenuTef', subcribleFunction);
    }
  }

  onMensagemTef(subcribleFunction) {
    if (this.signalR) {
      this.signalR.on('MensagemTef', subcribleFunction);
    }
  }

  onExibeQRCodeTef(subcribleFunction) {
    if (this.signalR) {
      this.signalR.on('ExibeQRCodeTef', subcribleFunction);
    }
  }

  invokeInicializaTef() {
    if (this.signalR) {
      return this.signalR.invoke('InicializaTef');
    }
  }

  invokeEfetuaPagamentoTef(documento, valor, modalidadeTef, multiplosPagamentos) {
    if (this.signalR) {
      return this.signalR.send('EfetuaPagamentoTef', documento, valor, modalidadeTef, multiplosPagamentos);
    }
  }

  invokeConfirmaPagamentoTef(documento, confirma) {
    if (this.signalR) {
      return this.signalR.invoke('ConfirmaTransacaoTef', documento, confirma);
    }
  }

  invokeCallbackTef(interromper, respostaSitef) {
    if (this.signalR) {
      return this.signalR.invoke('CallbackTef', interromper, respostaSitef);
    }
  }

  invokeAdministracaoTef() {
    if (this.signalR) {
      return this.signalR.invoke('AdministracaoTef');
    }
  }

  invokeCancelaPagamentoTef(documento) {
    if (this.signalR) {
      return this.signalR.invoke('CancelaPagamentoTef', documento?.toString());
    }
  }

  invokeInterrompeRequisicaoTef() {
    if (this.signalR) {
      return this.signalR.invoke('InterrompeRequisicaoTef');
    }
  }
}

export default TefService;
